export default __webpack_public_path__ + "static/media/chromebook.edb52f9d.webp";